export default {
    // 基本資料
    'system_id': {
        display: {
            name: '系統序號',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'system_id',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'title': {
        display: {
            name: '案名',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'title',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
            validator: [{ required: true, message: '必填', trigger: 'change' }],
        },
    },
    'abstract': {
        display: {
            name: '摘要',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'abstract',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-line-string',
        }
    },
    'keywords': {
        display: {
            name: '關鍵字',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'keywords',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-string',
        }
    },
    'recordgroup_name': {
        display: {
            name: '全宗名',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'recordgroup_name',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'recordgroup_number': {
        display: {
            name: '全宗號',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'recordgroup_number',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'recordgroup_keywords': {
        display: {
            name: '全宗關鍵字',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'recordgroup_keywords',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'recordgroup_abstract': {
        display: {
            name: '全宗摘要',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'recordgroup_abstract',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'sub_recordgroup_name': {
        display: {
            name: '次全宗名',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'sub_recordgroup_name',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'sub_recordgroup_number': {
        display: {
            name: '次全宗號',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'sub_recordgroup_number',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'sub_recordgroup_keywords': {
        display: {
            name: '次全宗關鍵字',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'sub_recordgroup_keywords',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'sub_recordgroup_abstract': {
        display: {
            name: '次全宗摘要',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'sub_recordgroup_abstract',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'series_name': {
        display: {
            name: '資料類型',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'series_name',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'folder_name': {
        display: {
            name: '案卷名',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'folder_name',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false
        }
    },
    'folder_number': {
        display: {
            name: '案卷號',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'folder_number',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false
        }
    },
    'folder_keywords': {
        display: {
            name: '案卷關鍵字',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'folder_keywords',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'folder_name_abstract': {
        display: {
            name: '案卷摘要',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'folder_name_abstract',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'remarks': {
        display: {
            name: '備註',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'remarks',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
        }
    },
    // 林業資料
    'business_district_forest': {
        display: {
            name: '林班',
            type: 'forestry-data',
        },
        source: {
            type: 'db',
            key: 'business_district_forest',
            data_type: 'string', // json string
        },
        change: {
            editable: true,
            addable: true,
            name: 'business_district_forest',
            type: 'forestry-data',
        }
    },
    'security_forest': {
        display: {
            name: '保安林',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'security_forest',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
        }
    },
    // 授權
    'original_owner': {
        display: {
            name: '原典藏單位',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'original_owner',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
        }
    },
    'obtained_price': {
        display: {
            name: '取得價格',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'obtained_price',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
        }
    },
    'authorization_status': {
        display: {
            name: '授權狀態',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'authorization_status',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['未完成授權','已完成授權','不授權','不須授權'].map(x=>({value:x, label:x}))
            }
        }
    },
    'authorization_scope': {
        display: {
            name: '授權範圍',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'authorization_scope',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['全部授權','部分授權'].map(x=>({value:x, label:x}))
            }
        }
    },
    'org_usage_scope': {
        display: {
            name: '單位使用範圍',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'org_usage_scope',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multiple-select-as-is',
            options: {
                type: 'fixed',
                list: ['授權網路','授權出版','授權展覽'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'original_property_number': {
        display: {
            name: '原始財產編號',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'original_property_number',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'rights_open': {
        display: {
            name: '是否於前臺開放',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'rights_open',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['是','否'].map(x=>({value:x, label:x}))
            },
            validator: [{ required: true, message: '必填', trigger: 'change' }],
        }
    },
    // 實體物件
    'archive_location': {
        display: {
            name: '存放地點',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'archive_location',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
        }
    },
    'archive_date': {
        display: {
            name: '存放日期',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'archive_date',
            data_type: 'datetime',
        },
        change: {
            editable: true,
            addable: true,
            type: 'datetime'
        }
    },
    'store_date': {
        display: {
            name: '登錄日期',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'archive_date',
            data_type: 'datetime',
        },
        change: {
            editable: true,
            addable: true,
            type: 'datetime'
        }
    },
    'archive_status': {
        display: {
            name: '狀態',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'archive_status',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['良好','毀損'].map(x=>({value:x, label:x})),
            },
        },
    },
    'longitude': {
        display: {
            name: '經度',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'longitude',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
            description: '範例：121.564558',
        }
    },
    'latitude': {
        display: {
            name: '緯度',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'latitude',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
            description: '範例：25.03746"',
        }
    },
}